export enum SignInStep {
  SignIn = 'SignIn',
  ForgotPassword = 'ForgotPassword',
  CreateAccount = 'CreateAccount',
  SentResetPasswordLink = 'SentResetPasswordLink',
  NotFoundContact = 'NotFoundContact',
  PrequalOtpVerification = 'PrequalOtpVerification',
  ResumeProcessOtpVerification = 'ResumeProcessOtpVerification',
}
